import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";

Vue.config.productionTip = false;

// In your main vue file - the one where you create the initial vue instance.
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css"; // only if your build system can import css, otherwise import it wherever you would import your css.
Vue.use(VuePlyr);

import shortkey from "vue-shortkey";
Vue.use(shortkey);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
